import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

type LinkTextComponentProps = {
  children: React.ReactNode
  className?: string
  href: string
  target?: '_blank'
  size?: string
}

const LinkTextStyle = styled(Link)<{size?: string}>`
  color: #383432;
  font-size: ${props => props.size || '16px'};
  text-decoration: none;

  :hover {
    color: #737373;
  }
`;

const LinkText: React.FC<LinkTextComponentProps> = ({ children, className, href, target, size }) => {
  return (
    <LinkTextStyle to={ href } className={ className } target={target} size={size}>
      { children }
    </LinkTextStyle>
  );
};

export default LinkText;
